import isArray from './is-array';
import isString from './is-string';
function endsWith(arr, e) {
    return isArray(arr) || isString(arr) ? arr[arr.length - 1] === e : false;
}
export default endsWith;
//# sourceMappingURL=ends-with.js.map